import React, { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { Tooltip } from 'primereact/tooltip'
import { getScc } from '../../services/searchPanelServices'
import CustomTooltip from '../../common/CustomTooltip/CustomTooltip'

const SccItem = ({ scc, isDisabled = false }) => {
	const [sccObj, setSccObj] = useState(scc)

	useEffect(() => {
		; (async (scc) => {
			let sccObj

			if (scc.sccDescription) {
				sccObj = scc
				setSccObj(sccObj)
			} else {
				const sccObj = await getScc(scc.scc)
				if (sccObj) {
					setSccObj(sccObj)
				} else {
					setSccObj(scc)
				}
			}
		})(scc)
	}, [scc])

	return (
		<>
			{sccObj ? (
				<>
					<div className={`scccode non-rem-scc-${sccObj.scc} ${isDisabled ? 'scc-disabled' : ''}`} id={`non-rem-scc-${sccObj.scc}`}>
						{sccObj.scc}
					</div>

					<CustomTooltip position='bottom' targetId={`non-rem-scc-${sccObj.scc}`} label={sccObj.sccDescription} />
				</>
			) : (
				<></>
			)}
		</>
	)
}

const SccListDisplay = ({
	nonRemovableSccs,
	additionalSccs,
	appliedServices,
	handleRemoveAdditionalScc,
	isDisabled = false,
	cargoCheck,
	setCargoCheck,
	autoAdd,
	//	services,
}) => {
	const [sccList, setSccList] = useState([])
	const canRemove = !isDisabled && typeof handleRemoveAdditionalScc === 'function'
	useEffect(() => {
		if (nonRemovableSccs) {
			var setObj = new Set()
			var result = nonRemovableSccs.reduce((acc, item) => {
				if (!setObj.has(item.scc)) {
					setObj.add(item.scc, item)
					acc.push(item)
				}
				return acc
			}, [])
			setSccList(result)
		}
	}, [])
	useEffect(() => {
		if (nonRemovableSccs) {
			var setObj = new Set()
			var result = nonRemovableSccs.reduce((acc, item) => {
				if (!setObj.has(item.scc)) {
					setObj.add(item.scc, item)
					acc.push(item)
				}
				return acc
			}, [])
			setSccList(result)
		}
	}, [nonRemovableSccs])
	return (
		<div className='scc-wrapper'>
			{sccList && sccList.length ? (
				sccList.map((scc, index) => (
					<span key={`apld-${index}`} className={isDisabled ? 'scc-chip-disabled' : ''}>
						<SccItem scc={scc} isDisabled={isDisabled} />
					</span>
				))
			) : (
				<></>
			)}
			{additionalSccs && additionalSccs.length ? (
				additionalSccs?.map((scc, index) => (

					<span key={`adtnl-${index}`} className={isDisabled ? 'scc-chip-disabled' : ''}>
						<div className={`scccode adtnl-scc-${index} pr-0 ${isDisabled ? 'scc-disabled' : ''}`} key={index} id={`adtnl-scc-${index}`}>
							{scc?.scc}
							<FontAwesomeIcon
								icon={faTimes}
								onClick={canRemove ? () => handleRemoveAdditionalScc(scc) : undefined}
								className={`close-button mx-1 ${isDisabled ? 'disabled no-pointer-events' : ''}`}
								aria-disabled={isDisabled}
							/>
						</div>
							<CustomTooltip targetId={`adtnl-scc-${index}`} position='bottom' label={scc?.sccDescription} />
					</span>
				))
			) : (
				<></>
			)}
			{appliedServices && appliedServices.length ? (
				appliedServices.map((scc, index) => {
					return (
						<span key={`adtnl-${index}`} className={isDisabled ? 'scc-chip-disabled' : ''}>
							<div className={`scccode service-scc-${index}  ${!autoAdd && 'pr-0'} ${isDisabled ? 'scc-disabled' : ''}`} key={index} id={`service-scc-${index}`}>
								{scc.scc}
								{!autoAdd ?
									<FontAwesomeIcon
										icon={faTimes}
										onClick={canRemove ? () => handleRemoveAdditionalScc(scc) : undefined}
										className={`close-button mx-1 ${isDisabled ? 'disabled no-pointer-events' : ''}`}
										aria-disabled={isDisabled}
									/> :
									<></>}
							</div>
								<CustomTooltip targetId={`service-scc-${index}`} position='bottom' label={scc.sccDescription} />
						</span>
					)
				})
			) : (
				<></>
			)}
		</div>
	)
}

export default SccListDisplay
